<template>
  <div class="wl-view">
    <b-overlay :show="loading">
      <wine-list-header
        v-if="!loading"
        :title="active_list.list_title"
        subtitle=""
        :slug="active_list.slug"
      ></wine-list-header>
      <div class="container-lg">
        <div class="row" v-if="active_list.list_description">
          <div class="col-12 mb-2">
            <div style="white-space: pre-line">
              {{ active_list.list_description }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-nav tabs>
              <b-nav-item
                :to="'/view/price-list/' + active_list.slug"
                :active="active_template === 'price-list'"
                v-if="
                  is_template_enabled('PRICE-YP') ||
                  is_template_enabled('PRICE-SELL') ||
                  is_template_enabled('PRICE-GLASS')
                "
                >Price List</b-nav-item
              >
              <b-nav-item
                :to="'/view/brochure/' + active_list.slug"
                :active="active_template === 'brochure'"
                v-if="is_template_enabled('BROCHURE')"
                >Interactive Fact Sheet</b-nav-item
              >
              <b-nav-item
                :to="'/view/wine-tasting/' + active_list.slug"
                :active="active_template === 'wine-tasting'"
                v-if="is_template_enabled('TASTING')"
                >Tasting Booklet</b-nav-item
              >
            </b-nav>

            <div class="wl-action-bar mb-3">
              <div class="row">
                <div class="col-12">
                  <b-nav small align="left">
                    <b-nav-item
                      v-if="active_list.can_edit"
                      title="Edit"
                      :to="'/edit/' + active_list.slug"
                      >Edit</b-nav-item
                    >

                    <b-nav-item
                      title="Download PDF"
                      :href="pdf_url"
                      target="_blank"
                      >Download PDF</b-nav-item
                    >
                    <b-nav-item
                      title="Download XLS"
                      v-if="active_template === 'price-list'"
                      :href="
                        '/download/wine-list/xls/price-list?id=' +
                        active_list.slug
                      "
                      target="_blank"
                      >Download XLS</b-nav-item
                    >
                  </b-nav>
                </div>
              </div>
            </div>

            <price-list
              v-if="
                active_template === 'price-list' &&
                (is_template_enabled('PRICE-YP') ||
                  is_template_enabled('PRICE-SELL') ||
                  is_template_enabled('PRICE-GLASS'))
              "
              :enabled-yp="is_template_enabled('PRICE-YP')"
              :enabled-sell="is_template_enabled('PRICE-SELL')"
              :enabled-glass="is_template_enabled('PRICE-GLASS')"
              :value-yp="get_template('PRICE')"
              :value-sell="get_template('PRICE')"
              :value-glass="get_template('PRICE')"
              :slug="active_list.slug"
              view-mode
            ></price-list>

            <interactive-brochure
              v-if="
                active_template === 'brochure' &&
                is_template_enabled('BROCHURE')
              "
              :value="get_template('BROCHURE')"
              :slug="active_list.slug"
              view-mode
            ></interactive-brochure>

            <wine-tasting
              v-if="
                active_template === 'wine-tasting' &&
                is_template_enabled('TASTING')
              "
              :value="get_template('TASTING')"
              :slug="active_list.slug"
              :hide-glass="!is_template_enabled('PRICE-GLASS')"
              view-mode
            ></wine-tasting>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import PriceList from "@/components/winelist/WineListPriceList";
import InteractiveBrochure from "@/components/winelist/WineListBrochure";
import WineTasting from "@/components/winelist/WineListTasting";
import WineListHeader from "@/components/winelist/WineListHeader";

import jbs_api from "@/modules/jbs-api";

export default {
  components: {
    PriceList,
    InteractiveBrochure,
    WineTasting,
    WineListHeader,
  },
  data() {
    return {
      id: "",
      active_template: "",
      active_list: false,
      loading: true,
    };
  },
  mounted() {
    this.id = this.$route.params.id;

    jbs_api
      .get("WineList", { params: { slug: this.id, readonly: true } })
      .then((response) => {
        this.active_list = response.data;
        this.loading = false;
        this.updateNavigation();
      });
  },
  methods: {
    is_template_enabled(template) {
      if (!this.active_list) {
        return false;
      }
      return this.active_list.settings.templates.indexOf(template) !== -1;
    },
    get_template(template) {
      if (!this.active_list) {
        return [];
      }
      return this.active_list.templates[template];
    },
    updateNavigation() {
      if (this.$route.params.template) {
        this.active_template = this.$route.params.template;
      } else {
        if (
          this.is_template_enabled("PRICE-YP") ||
          this.is_template_enabled("PRICE-SELL") ||
          this.is_template_enabled("PRICE-GLASS")
        ) {
          this.$router.replace("/view/price-list/" + this.id);
          return;
        }
        if (this.is_template_enabled("BROCHURE")) {
          this.$router.replace("/view/brochure/" + this.id);
          return;
        }
        if (this.is_template_enabled("TASTING")) {
          this.$router.replace("/view/wine-tasting/" + this.id);
          return;
        }
      }
    },
  },
  computed: {
    pdf_url() {
      switch (this.active_template) {
        case "brochure":
          return "/download/wine-list/pdf/brochure?id=" + this.active_list.slug;
        case "wine-tasting":
          return "/download/wine-list/pdf/tasting?id=" + this.active_list.slug;
        case "price-list":
          return (
            "/download/wine-list/pdf/price-list?id=" + this.active_list.slug
          );
      }

      return "";
    },
  },
  watch: {
    "$route.params.template"() {
      this.updateNavigation();
    },
  },
};
</script>
